// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale":"amazon-sale_amazon-sale__R_A29"};